import React from "react";
import axios from 'axios'
import {message,notification} from "antd";
import {Auth} from '@q4us-sw/q4us-ui'
import {Trans} from "react-i18next";
const {MIME_TYPE} = require('../utils/constants')
/**/
if(process.env.REACT_APP_SERVER_URL){
    axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
}

axios.interceptors.request.use(async (cfg)=>{
    //skip auto header attachment from auth requests
    cfg.url = `/internal${cfg.url}`
    if(Auth.isConfigured() && Auth.isSignedIn() && cfg.url !== "/internal/api/auth/open-id/connect"){
        const token = await Auth.getToken();
        cfg.headers["Authorization"] = `Bearer ${token}`;
    }
    return cfg;
}, async err=>{
    notification.error({message: err.message});
})


axios.interceptors.response.use(res=> {
    if(res){
        const {data:{statusCode = 200,message: str} = {}} = res || {}
        if(statusCode !== 200){
            if(str)
                notification.error({message: <Trans i18nKey={str} defaults={str}/> })
            else
                notification.error({message: `Failed with status ${statusCode}`})

            res.status = statusCode;
        }
    }
    return res;
}, async (error)=>{
    const {response: {data = {}} = {}, request: {responseType}} = error

    if(responseType === 'blob'){
        let {message} = JSON.parse(await data.text() || {});
        notification.error({message: message || error.message})
    }
    else{
        notification.error({message: data.message || error.message})
    }
});


export const dummy = async ()=>{
    await new Promise(r => setTimeout(r, 2000));
    return {}
}

export const resetPassword = async (email)=>{
    return axios.post('/api/auth/password/reset', {email})
}
export const updateSelfRegPassphrase = async (value)=>{
    return axios.post('/api/self-reg/passphrase/update', {passphrase: value})
}

export const updateEASInfo = async ({key, value})=>{
    return await axios.post('/api/persistence/update_eas_info', {key,value: value !== null ? `${value}`: value})
}

export const getAuditTrail = async ([from,to])=>{
    return await axios.get(`/api/visualize/audit_trail/${from}/${to}`)
}

export const getFeConfig = async (id)=>{
    return await axios.get(`/api/config/${id}`)
}

export const submitEM = async (data)=>{
    return axios.post(`/api/register/em`, data);
}

export const visualize = async (id)=>{
    return await axios.get(`/api/visualize/${id}`)
}

export const visualize_exchange_noneu = async (country_code)=> {
    return await axios.get(`/api/visualize/exchange_rates_non_eu`, {params:{country_code:country_code}})
}

export const dashboard_users = async (group = 'all', data = {})=>{
    return await axios.post(`/api/dashboard/users/${group}`, data)
}
export const dashboard_groups = async (user_id)=>{
    return await axios.get(`/api/dashboard/groups/${user_id}`)
}
export const dashboard_attach_group = async (user_id,group)=>{
    return await axios.post(`/api/dashboard/users/attach`,{user_id, group})
}
export const dashboard_detach_group = async (user_id,group)=>{
    return await axios.post(`/api/dashboard/users/detach`, {user_id, group})
}
export const emAssignment = async (data)=>{
    return await axios.post(`/api/visualize/em_assignment`, data)
}

export const visualizeLoad = async (data)=>{
    return await axios.post(`/api/visualize/load`, data)
}

export const visualizeLoadFiscalReportList = async (data)=>{
    return await axios.post(`/api/visualize/load_fiscal_report_list`, data)
}

export const downloadFiscalReportInXlsx = async (data)=>{

    const {data: out} = await axios({
        url: `/api/v2/export/xlsx`,
        method: 'POST',
        responseType: 'blob',
        data
    });
    const blobStore = new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `Fiscal Reports.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const visualizeLoadCustomDutyNorway = async (data)=>{
    return await axios.post(`/api/visualize/load_customDuty_norway`, data)
}

export const visualizeLoadInvoice = async (data)=>{
    return await axios.post(`/api/visualize/load_invoice`, data)
}

export const visualizeWithFilters = async (id, filters)=>{
    return await axios.post(`/api/visualize/${id}`, {filters})
}

export const visualizeWithFilter = async ({tableName, conditions})=>{
    return await axios.post(`/api/persistence/find`, {tableName, conditions})
}

export const visualizeorderbreakdown = async (id)=>{
    return await axios.get(`/api/visualize/orderitems/${id}`)
}

export const visualizeshipmentbreakdown = async (id)=>{
    return await axios.get(`/api/visualize/shipmentitems/${id}`)
}

export const submitRefTableData = async (data, tableName, options = {}) => {
    return await axios.post(`/api/persistence/update`, {data,tableName, ...options});
}

export const updateGeneralContract = async (data, tableName, options = {}) => {
    return await axios.post(`/api/persistence/updateGeneralContract`, {data,tableName});
}

export const updateEmContract = async (data, tableName, options = {}) => {
    return await axios.post(`/api/persistence/updateEmContractDoc`, {data,tableName});
}

export const submitDataWithConditions = async (tableName, data, conditions) => {
    return await axios.post(`/api/persistence/update_with_conditions`, {data,tableName,conditions});
}

export const testUpdateFCCDate = async (data) => {
    return await axios.post('/test/persistence/update_fcc_date', data)
}

export const testUpdateDiscountCreatedDate = async (data) => {
    return await axios.post('/test/persistence/update_discount_created_date', data)
}

export const testUpdateReturnConfirmedDate = async (data) => {
    return await axios.post('/test/persistence/update_return_confirmed_date', data)
}

export const testVerifyPayment = async (data) => {
    return await axios.post('/test/persistence/payment_verify_order', data);
}

export const testUpdateShipmentTimestamp = async (data) => {
    return await axios.post('/test/persistence/update_shipment_timestamp', data);
}

export const updateSelfRegApplication = async (data, status) => {
    return await axios.post(`/api/persistence/update_self_reg_application`, {data,status});
}

export const submitFeeClassTableData = async (data) => {
    return await axios.post(`/api/persistence/update_fee_class`, {data});
}

export const submitHS6PRefTableData = async(data) => {
    return await axios.post(`/api/persistence/update_hs6p_ref`, {data});
}

export const insertNewRefTableData = async (data, tableName, returnColumns = ["id"]) => {
    return await axios.post(`/api/persistence/insert`, {data,tableName, returnColumns});
}

export const selfRegInvite = async (email) => {
    return await axios.post(`/api/register/invite`, {email});
}

export const insertHS6PNewRefTableData = async (data) => {
    return await axios.post(`/api/persistence/insert_hs6p_ref`, {data});
}

export const updateDailyExchangeRates = async () => {
    return await axios.get(`/api/persistence/updatedailyexchangerates`);

}

export const updateExchangeRatesNonEU = async (variables) => {
    return await axios.post(`/api/persistence/updateExchangeRatesNonEU`, {variables});

}

export const updateAnnualExchangeRates = async () => {
    return await axios.get(`/api/persistence/updateannualexchangerates`);

}

export const updateSDRExchangeRate = async () => {
    return await axios.get(`/api/persistence/update_sdr_exchange_rate`);
};

export const uploadFile = async (data) => {
    return await axios.post(`/api/persistence/upload_file`, data);
};

export const uploadNorwayCustomDutyFile = async (data) => {
    return await axios.post(`/api/persistence/upload_norway_custom_duty_file`, data);
};

export const syncVATRates = async () => {
    return await axios.get('/api/persistence/synccountryvatrates')
}

export const cancelFileUploadJob = async (data)=>{
    return await axios.post(`/api/persistence/cancel_file_upload_job`, data)
}

export const visualizeordersplits = async (id)=>{
    return await axios.get(`/api/visualize/order_splits/${id}`)
}

export const visualizeordershipments = async (id)=>{
    return await axios.get(`/api/visualize/order_shipments/${id}`)
}

export const visualizesplitbreakdown = async (id)=>{
    return await axios.get(`/api/visualize/split_items/${id}`)
}

export const visualizeCustomsDutyRates = async (country)=>{
    return await axios.get(`/api/visualize/customsdutyrates/${country}`)
}

export const visualizeCountryVatRates = async (country)=>{
    return await axios.get(`/api/visualize/countryvatrates/${country}`)
}

export const visualizeNonEUSupportedCountryVatRates = async (country)=>{
    return await axios.get(`/api/visualize/noneusupportedvatrates/${country}`)
}

export const visualizeCountryVatItems = async (id)=>{
    return await axios.get(`/api/visualize/countryvatitems/${id}`)
}

export const visualizeCountryVatItemsNonEU = async (id)=>{
    return await axios.get(`/api/visualize/countryvatitemsnoneu/${id}`)
}

export const visualizeCountryAlpha2 = async ()=> {
    return await axios.get(`/api/visualize/countryalpha2`)
}

export const visualizeNonEUSupportedCountryAlpha2 = async ()=> {
    return await axios.get(`/api/visualize/nonEUsupportedalpha2`)
}

export const visualizeCustomsDutyCountries = async ()=>{
        return await axios.get(`/api/visualize/customsdutycountries`);
}

export const schedules = async ()=>{
    return await axios.get(`/api/schedules`)
}

export const getGracePeriod = async ()=>{
    return await axios.get(`/api/visualize/grace_period`);
}

export const updateSchedule = async (data)=>{
    return await axios.post(`/api/schedules/update`, data)
}
export const invokeSchedule = async (data)=>{
    return await axios.post(`/api/schedules/invoke`, data)
}

export const completeInvoice = async (data)=>{
    return await axios.post(`/api/invoice/update`, data)
}

export const invoiceComment = async (data)=>{
    return await axios.post(`/api/invoice/update_comment`, data)
}

export const fiscalReportComment = async (data)=>{
    return await axios.post(`/api/em_vat_fiscal_report/update_fiscal_report_comment`, data)
}

export const setFiscalVATPayment = async (data)=>{
    return await axios.post(`/api/em_vat_fiscal_report/update_fiscal_report_payment`, data)
}
export const sendFiscalVATNotification = async (data)=>{
    return await axios.post(`/api/em_vat_fiscal_report/send_notification`, data)
}

export const invoiceCommunicationStatus = async (data)=>{

    var tblname = 'invoice_new';
    if (data.invoice_id > 1000000 && data.invoice_id < 7000000){
        tblname = 'cc.invoice_addons';
    }

    if (data.invoice_id >= 7000000 && data.invoice_id < 12000000){
        tblname = 'invoice_mcg';
    }
    if (data.invoice_id >= 12000000){
        tblname = 'invoice_gpsr';
    }
    
    return await axios.post(`/api/persistence/update`, {tableName: tblname, data: {communication_status: data.communication_status, id: data.invoice_id}})
}

export const InvoiceGenericExportReport = async (data_param)=>{
    const {data} = await axios({
        url: `/api/invoice/invoice_list_excel_export`,
        method: 'POST',
        responseType: 'blob',
        data: data_param
    });
    const blobStore = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `Aggregated_Invoices_EAS_solution.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const testUpdatePostSalePaymentDate = async (data) => {
    return await axios.post('/test/persistence/update_post_sale_payment_date', data);
}

export const testInvokeInvoiceDirectSchedule = async () => {
    return await axios.post(`/test/persistence/invoke_invoice_direct`);
}

export const testInvokeInvoiceIndirectSchedule = async () => {
    return await axios.post(`/test/persistence/invoke_invoice_indirect`);
}

export const testGeneratePastInvoices = async (data) => {
    return await axios.post(`/test/persistence/generate_past_invoices`, data);
};

export const testGeneratePastFiscalReportsImport = async (data) => {
    return await axios.post(`/test/persistence/generate_past_reports_fiscal_import`, data);
};

export const testGeneratePastFiscalReportsNonEuGB = async (data) => {
    return await axios.post(`/test/persistence/generate_past_reports_fiscal_non_eu_gb`, data);
};

export const testGeneratePastFiscalReportsNonUnion = async (data) => {
    return await axios.post(`/test/persistence/generate_past_reports_fiscal_non_union`, data);
};

export const testGeneratePastFiscalReportsUnion = async (data) => {
    return await axios.post(`/test/persistence/generate_past_reports_fiscal_union`, data);
};

export const invoice = async (em_id, invoice_id, fileName)=>{
    const {data} = await axios({
        url: `/api/invoice/${em_id}/${invoice_id}/pdf`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'application/pdf' });
    // const file = new File([blobStore], `Invoice ${invoice_id}-${em_id}`, {
    //     type: blobStore.type,
    // });
    // blobStore.lastModifiedDate = new Date();
    // blobStore.name = `Invoice ${invoice_id}-${em_id}.pdf`;
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const invoice_udr = async (em_id, invoice_id, duration)=>{

    message.loading(`Preparing Download`, 0)
    let message_count = 0;
    const format = 'csv';
    const {data} = await axios({
        url: `/api/invoice_udr/${em_id}/${invoice_id}/${duration}/csv`,
        method: 'GET',
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
            if(message_count===0){
                message.destroy()
                message.loading(`Downloading`, 0)
                message_count++
            }

        }
    });

    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    message.destroy()
    message.success('Downloaded', 2.5)

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `invoice_udr_${em_id}_${invoice_id}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const lastInvoice = async (em_id)=>{
    const {data: {statusCode, rows}} = await axios.get(`/api/last_invoice/${em_id}`);
    const {id:invoice_id} = rows[0];
    return await invoice(em_id, invoice_id, `Invoice ${invoice_id}-${em_id}.pdf`);
}

export const emVatReportList = async ({id, report_type})=>{
    return await axios.get(`/api/em_vat_report_list/${id}/${report_type}`)
}

export const em_vat_report = async (em_id, report_type, report_id, duration, country ,format = 'pdf')=>{

    message.loading(`Preparing Download`, 0)
    let message_count = 0;

    let apiCall = {};

    if (country !== undefined) {
        apiCall = axios({
            url: `/api/em_vat_report/${em_id}/${report_type}/${report_id}/${duration}/${country}/${format}`,
            method: 'GET',
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                if(message_count===0){
                    message.destroy()
                    message.loading(`Downloading`, 0)
                    message_count++
                }

            }
        });
    } else {
        apiCall = axios({
            url: `/api/em_vat_report/${em_id}/${report_type}/${report_id}/${duration}/${format}`,
            method: 'GET',
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                if(message_count===0){
                    message.destroy()
                    message.loading(`Downloading`, 0)
                    message_count++
                }

            }
        });
    }

    const {data} = await apiCall;

    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    message.destroy()
    message.success('Downloaded', 2.5)

    if(format === 'pdf'){
        window.open(url, `em_vat_report_${em_id}_${report_id}.pdf`, params)
    }
    else if(format === 'csv'){
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = `em_vat_report_${em_id}_${report_id}_${Date.now()}.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
    else{
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = `em_vat_report_${em_id}_${report_id}.${format}`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}

export const emVatReportFiscalImportList = async ({em_id})=>{
    return await axios.get(`/api/em_vat_report_fiscal/import/${em_id}`)
}

export const em_vat_report_fiscal_import = async (em_id, month, year, format = 'pdf', em_identifier, scheme_registered_country_code) => {
    const { data } = await axios({
        url: `/api/em_vat_report_fiscal/import/${em_id}/${month}/${year}/${format}/${scheme_registered_country_code}`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;

    if (format === 'pdf') {
        a.download = `IOSS ${month}-${year} ${em_identifier}`;
    }
    else if (format === 'csv') {
        a.download = scheme_registered_country_code === 'DE' ? `IOSS_${year}_${month}.csv` : `em_vat_report_fiscal_import_${em_id}_${month}_${Date.now()}.zip`;
    }
    else {
        a.download = `em_vat_report_fiscal_import_${em_id}_${month}.${format}`;
    }
    a.click();
    window.URL.revokeObjectURL(url);
}

export const em_vat_report_fiscal_non_eu_gb = async (em_id, month, year, format = 'csv') => {
    const { data } = await axios({
        url: `/api/em_vat_report_fiscal/non_eu_gb/${em_id}/${month}/${year}/${format}`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `em_vat_report_fiscal_non_eu_gb_${em_id}_${month}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const emVatReportFiscalNonUnionList = async ({em_id})=>{
    return await axios.get(`/api/em_vat_report_fiscal/non_union/${em_id}`)
}

export const em_vat_report_fiscal_non_union = async (em_id, quarter, year, format = 'pdf', em_identifier, scheme_registered_country_code)=>{
    const { data } = await axios({
        url: `/api/em_vat_report_fiscal/non_union/${em_id}/${quarter}/${year}/${format}/${scheme_registered_country_code}`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;

    if (format === 'pdf') {
        a.download = `NON-UNION Q${quarter}-${year} ${em_identifier}`;
    }
    else if (format === 'csv') {
        a.download = scheme_registered_country_code === 'DE' ? `OSS_NON-UNION_${year}_${quarter}.csv` : `em_vat_report_fiscal_non_union_${em_id}_${quarter}_${Date.now()}.zip`;
    }
    else {
        a.download = `em_vat_report_fiscal_non_union_${em_id}_${quarter}.${format}`;
    }
    a.click();
    window.URL.revokeObjectURL(url);
}

export const emVatReportFiscalUnionList = async ({em_id})=>{
    return await axios.get(`/api/em_vat_report_fiscal/union/${em_id}`)
}

export const em_vat_report_fiscal_union = async (em_id, quarter, year, format = 'pdf', em_identifier, scheme_registered_country_code) => {
    const { data } = await axios({
        url: `/api/em_vat_report_fiscal/union/${em_id}/${quarter}/${year}/${format}/${scheme_registered_country_code}`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;

    if (format === 'pdf') {
        //window.open(url, `em_vat_report_fiscal_union_${em_id}_${quarter}.${format}`, params)
        a.download = `OSS Q${quarter}-${year} ${em_identifier}`;
    }
    else if (format === 'csv') {
        a.download = scheme_registered_country_code === 'DE' ? `OSS_UNION_${year}_${quarter}.csv` : `em_vat_report_fiscal_union_${em_id}_${quarter}_${Date.now()}.zip`;
    }
    else {
        a.download = `em_vat_report_fiscal_union_${em_id}_${quarter}.${format}`;
    }
    a.click();
    window.URL.revokeObjectURL(url);
}

export const emVatReportFiscalVATCorrections = async (type)=>{
    return await axios.get(`/api/visualize/em_vat_report_fiscal_corrections/${type}`)
}

export const emVatReportFiscalVATCorrectionsAction = async (data)=>{
    return await axios.post(`/api/em_vat_report_fiscal_corrections/action`, data)
}

export const testEmVatReportFiscalVATCorrectionsAction = async (data)=>{
    return await axios.post(`/test/em_vat_report_fiscal_corrections/action`, data)
}

export const dpoReport = async (id, effective_month, format)=>{
    const {data} = await axios({
        url: `/api/report/dpo_report/${id}/${effective_month}/${format}`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: MIME_TYPE[`${format}`] });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    if ( format === 'pdf') {
        window.open(url, `dpo_report_${id}_${effective_month}.pdf`, params)
    }
    else {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = `dpo_report_${id}_${effective_month}_${Date.now()}.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
    }
}

export const dpoReportSplits = async (id, effective_month)=>{
    const {data} = await axios({
        url: `/api/report/dpo_report_splits/${id}/${effective_month}/csv`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `dpo_handled_order_report_${id}_${effective_month}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const dpoReportList = async ({id})=>{
    return await axios.get(`/api/report/dpo_report_list/${id}`)
}

export const dpoLatestReport = async ()=>{
    return await axios.get(`/api/report/dpo_report_latest`)
}

export const completeDPOReport = async (data)=>{
    return await axios.post(`/api/report/dpo_report/update`, data)
}

export const customsReportSplits = async (id, effective_month)=>{
    const {data} = await axios({
        url: `/api/report/customs_report_splits/${id}/${effective_month}/csv`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `customs_handled_order_report_${id}_${effective_month}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const customsReportList = async ({id})=>{
    return await axios.get(`/api/report/customs_report_list/${id}`)
}

export const customsLatestReport = async ()=>{
    return await axios.get(`/api/report/customs_report_latest`)
}

export const emFCModeReport = async (id, effective_month)=>{
    const {data} = await axios({
        url: `/api/report/em_fc_mode_report/${id}/${effective_month}/csv`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `em_fc_mode_report_${id}_${effective_month}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const emFCModeReportList = async ({id})=>{
    return await axios.get(`/api/report/em_fc_mode_report_list/${id}`)
}

export const emInterimReport = async (em_id, id, duration)=>{
    const {data} = await axios({
        url: `/api/report/em_interim_report/${em_id}/${id}/${duration}/csv`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `em_interim_report_${em_id}_${id}_${Date.now()}.zip`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const emInterimReportList = async ({id})=>{
    return await axios.get(`/api/report/em_interim_report_list/${id}`)
}

export const hs6pReportList = async (id)=>{
    return await axios.get(`/api/report/hs6p/list/${id}`)
}

export const hs6pReport = async (subcontractor, report_id)=>{
    const {data} = await axios({
        url: `/api/report/hs6p/${subcontractor}/${report_id}/pdf`,
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    window.open(url, `${report_id}.pdf`, params)

}

export const visualizeCustomsForm = async (shipment_id, name)=>{
    return await axios.get(`/api/${name}/${shipment_id}/pdf`, {responseType: 'blob'});
};

export const visualizeCustomsDeclaration = async (shipment_id)=>{
    return await axios.get(`/api/customs_declaration/${shipment_id}`, { "Content-Type": "text/xml; charset=utf-8"});
};

export const visualizeQR = async (shipment_id)=>{
    return await axios.get(`/api/shipment/qr?shipment_id=${shipment_id}`, {responseType: 'blob'});
};

export const visualizeMonthlyRiskReport = async ()=>{
    return await axios.get(`/api/risk/monthly/pdf`, {responseType: 'blob'});
};

export const visualizeBarcode = async (shipment_id)=>{
    return await axios.get(`/api/shipment/barcode?shipment_id=${shipment_id}`, {responseType: 'blob'});
};

export const visualizeSpecialTerritoryPostalCodes = async (id)=>{
    return await axios.get(`/api/visualize/special_territory_postal_codes/${id}`)
};

export const submitSpecialTerritoryPostalCodes = async (data) => {
    return await axios.post(`/api/persistence/update_special_territory_postal_codes`, {data});
};

export const visualizeEMDCobrandImage = async (id, img)=>{
    const {data} = await axios.get(`/api/visualize/emd_cobranding/img/${id}/${img}`, {responseType: 'blob'});
    const blobStore = new Blob([data], { type: 'image/png' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
    window.open(url, `${img}.png`, params)
};

export const visualizeEMDCobrandCSS = async (id)=>{
    const {data} = await axios.get(`/api/visualize/emd_cobranding/css/${id}`, {responseType: 'blob'});
    const blobStore = new Blob([data], { type: 'text/css' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
    window.open(url, `primary.css`, params)
};

export const updateEMDCobrandImage = async (body) => {
    return await axios({
        url: `/api/persistence/emd_cobranding_img`,
        data: body,
        method: 'POST'
    }) || {};
}

export const updateEMDCobrandCSS = async (body) => {
    return await axios({
        url: `/api/persistence/emd_cobranding_css`,
        data: body,
        method: 'POST'
    }) || {};
}

//authentication

export const signIn = async (user,pass)=>{
    const {data} = await axios.post('/api/auth/open-id/connect', {
        grant_type:"password",
        password:pass,
        username:user
    }) || {}

    return data || {};
}
export const signInWithCode = async (code,redirect_uri)=>{
    const {data} = await axios.post('/api/auth/open-id/connect', {
        grant_type:"authorization_code",
        code,
        redirect_uri
    }) || {}

    return data || {};
}

export const signOut = async (refresh_token)=>{
    const {data} = await axios.post(`/api/auth/open-id/logout`, {
        token:refresh_token
    }) || {}

    return data || {};
}



export const auth_cfg = async ()=>{
    return axios.get('/api/auth/cfg')
}


export const refreshToken = async (token)=>{
    const {data} = await axios.post('/api/auth/open-id/connect', {
        grant_type:"refresh_token",
        refresh_token:token,
    }) || {}

    return data || {};
}



export const fetchDocument = async (em_id, document_id,file)=>{
    const {data, headers} = await axios({
        url: `/api/visualize/self_reg_document`,
        data: {id: document_id},
        method: 'POST',
        responseType: 'blob',
    }) || {};

    const url = window.URL.createObjectURL(new Blob([data]));
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    const name = headers['x-suggested-filename']
    a.download = name ? `[${`${em_id}`.padStart(6,'0')}]-${name}` : `[${`${em_id}`.padStart(6,'0')}]-${file}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const uploadGDPR = async (data)=>{
    return axios.post('/api/gdpr/save', data)
}

export const fetchGDPR = async (language)=>{
    const {data} = await axios({
        url: `/api/visualize/gdpr`,
        params:{
            language: language
        },
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    window.open(url, `GDPR`, params)
}

export const uploadAttachment = async (data)=>{
    return axios.post('/api/direct_message_attachment', data)
}

export const fetchDirectMessageAttachment = async (oid, filename)=>{
    const {data} = await axios({
        url: `/api/visualize/direct_message_attachment`,
        params:{oid},
        method: 'GET',
        responseType: 'blob',
    });
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blobStore = new Blob([data], {type: "octet/stream"});
    const url = window.URL.createObjectURL(blobStore);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const uploadDataSecurityAgreement = async (data)=>{
    return axios.post('/api/datasecurityagreement/save', data)
}

export const fetchDataSecurityAgreement = async (language)=>{
    const {data} = await axios({
        url: `/api/visualize/datasecurityagreement`,
        params:{
            language: language
        },
        method: 'GET',
        responseType: 'blob',
    });
    const blobStore = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blobStore);
    const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;

    window.open(url, `Data Security Agreement`, params)
}

export const uploadGeneralContract = async (data)=>{
    return axios.post('/api/generalContract/save', data)
}

export const insertIntermediaryInfo = async (data)=>{
    return axios.post('/api/intermediaryInfo/save', data)
}
export const updateIntermediaryInstructionFile = async (data)=>{
    return axios.post('/api/intermediaryInstructionFile/update', data)
}

export const updateAccessInformation = async (id, access_information)=>{
    return axios.post('/api/persistence/accessInfo/update', {id, access_information})
}

export const replaceGeneralContract = async (data)=>{
    return axios.post('/api/generalContract/replace', data)
}

export const fetchGeneralContract = async (id, name)=>{
    const {data} = await axios({
        url: `/api/visualize/fetch_general_contract`,
        data: {id: id},
        method: 'POST',
        responseType: 'blob',
    }) || {};
    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${name}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const fetchIntermediaryInstructions = async (id, name)=>{
    const {data} = await axios({
        url: `/api/visualize/fetch_intermediary_instruction`,
        data: {id: id},
        method: 'POST',
        responseType: 'blob',
    }) || {};
    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${name}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const fetchPreviousGeneralContract = async (id)=>{
    const {data, headers} = await axios({
        url: `/api/visualize/fetch_previous_general_contract`,
        data: {id: id},
        method: 'POST',
        responseType: 'blob',
    }) || {};
    const fileName = headers['x-suggested-filename']
    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${fileName}`;
    a.click();
    window.URL.revokeObjectURL(url);
}


export const deleteGeneralContract = async (id) => {
    return await axios.delete(`/api/persistence/deleteDocument/${id}`);
}

export const uploadEMContract = async (body)=>{
    return await axios({
        url: `/api/emContract/save`,
        data: body,
        method: 'POST'
    }) || {};
}

export const deleteEMContract = async (id, em_id) => {
    return await axios.delete(`/api/persistence/delete_em_contract/${id}/${em_id}`);
}

export const fetchEMContract = async (id, name)=>{
    const {data} = await axios({
        url: `/api/visualize/fetch_em_contract`,
        data: {id: id},
        method: 'POST',
        responseType: 'blob',
    }) || {};

    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${name}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const fetchPreviousEMContract = async (id, em_id)=>{
    const {data, headers} = await axios({
        url: `/api/visualize/fetch_previous_em_contract`,
        data: {id: id, em_id: em_id},
        method: 'POST',
        responseType: 'blob',
    }) || {};

    const fileName = headers['x-suggested-filename']
    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${fileName}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const replaceEMContract = async (data)=>{
    return axios.post('/api/emContract/replace', data)
}

export const error_log_report = async ()=>{

    message.loading(`Preparing Download`, 0)
    const {data} = await axios({
        url: `/api/visualize/error_log_report`,
        method: 'GET',
        responseType: 'stream',
    })|| {};
    const blobStore = new Blob([data], { type: MIME_TYPE[`csv`] });
    const url = window.URL.createObjectURL(blobStore);

    message.destroy()
    message.success('Downloaded', 2.5)

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `error_log_report_${Date.now()}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const sendEmailforIossReports = async (em_id, report_month, report_year, scheme_registered_country)=>{
    return axios.post(`/api/notification/sendEmailForIossReport/${em_id}`, {report_month, report_year, scheme_registered_country});
}

export const sendEmailforOssUnionReport = async (em_id, report_quarter, report_year, scheme_registered_country)=>{
    return axios.post(`/api/notification/sendEmailForOssUnionReport/${em_id}`, {report_quarter, report_year, scheme_registered_country});
}

export const operator_users = async (data)=>{
    return await axios.post(`/api/operator/users`, data)
}

export const userNotificationSubscription = async (user)=>{
    return await axios.get(`/api/operator/fetch_notification_subscriptions/${user}`)
}

export const submitNotificationSubscription = async (data, user)=>{
    return axios.post(`/api/operator/update_notification_subscription`, {data, user})
}

export const disableUserAccess = async (status, id)=>{
    return axios.post(`/api/operator/disable_access`, {status: status, id: id})
}

export const sendEmailforOssNonUnionReport = async (em_id, report_quarter, report_year, scheme_registered_country)=>{
    return axios.post(`/api/notification/sendEmailForOssNonUnionReport/${em_id}`, {report_quarter, report_year, scheme_registered_country});
}

export const sendEmailForInvoice = async (em_id, invoice_id, invoice_number, timestamp, client_number,
                                          due_date, reference_number, payment_status, communication_status,
                                          eur_amount, paid_amount) => {
    return axios.post(`/api/notification/sendEmailForInvoice/${em_id}`,
        {invoice_id, invoice_number, timestamp, client_number,
            due_date, reference_number, payment_status, communication_status, eur_amount, paid_amount});
}

export const sendEmailForDirectMessage = async (data) => {
    return axios.post(`/api/notification/sendEmailForDirectMessage`, data);
}


export const notificationSubscribers = async (email)=>{
    return await axios.get(`/api/visualize/fetch_notification_subscribers/${email}`)
}

export const submitNotificationSubscribers = async (data, user)=>{
    return axios.post(`/api/notification/update_notification_subscribers`, {data, user})
}

export const insertNotificationSubscribers = async (data) => {
    return await axios.post(`/api/notification/insert_notification_subscribers`, {data});
}

export const insertNewNotificationType = async (notificationType) => {
    return await axios.post(`/api/notification/insert_new_notification_type`, {notificationType});
}

export const sendPersonInfo = async (full_name, nominated_email, nominated_person, nominated_email_secondary, nominated_person_secondary, id, identifier) => {
    return await axios.post(`/api/register/nominated_person_account`, {full_name, nominated_email, nominated_person, nominated_email_secondary, nominated_person_secondary, id, identifier})
}

export const dashboardUserResetPassword = async (id)=>{
    return axios.post('/api/auth/password/dashboard_user_reset_password', {id})
}

export const insertIntermediaryWithoutFile = async (intermediary_name, country_of_registration, scheme, access_information)=>{
    return axios.post('/api/persistence/insert_intermediary_without_file', {intermediary_name, country_of_registration, scheme, access_information})
}

export const getCountries = async ({country_group})=>{
    return axios.get(`/api/visualize/get_countries/${country_group}`)
}

export const visualizeLoadVATReports = async (data) => {
    return axios.post('/api/visualize/load_fiscal_report_list', data)
}

export const VATFiscalGenericExportReport = async (data_param)=>{
    const {data} = await axios({
        url: `/api/invoice/fiscal_cat_report_list_excel_export`,
        method: 'POST',
        responseType: 'blob',
        data: data_param
    });
    const blobStore = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = window.URL.createObjectURL(blobStore);

    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `Fiscal Reports register.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);

}

export const blockEM = async (data, status) => {
    return axios.post('/api/persistence/block_em',{...data, status: status})
}

export const loadEmList = async (data)=>{
    return await axios.post(`/api/visualize/loadEMs`, data)
}

export const fetchSupportiveDocument = async (id, tableName, fileName)=>{
    const {data} = await axios({
        url: `/api/visualize/fetch_em_vat_correction_supportive_document`,
        data: {id: id, tableName: tableName},
        method: 'POST',
        responseType: 'blob',
    }) || {};
    const blobStore = new Blob([data]);
    const url = window.URL.createObjectURL(blobStore);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = `${fileName}`;
    a.click();
    window.URL.revokeObjectURL(url);
}

export const getTopClientsInfo = async ()=>{
    return await axios.get(`/api/cache/fetch_top_clients_info`)
}

export const refreshTopClientsInfo = async ()=>{
    return await axios.post(`/api/cache/refresh_top_clients_info`)
}

export const getOrderCountPerDay = async ()=>{
    return await axios.get(`/api/cache/fetch_order_count_per_day`)
}

export const refreshOrderCountPerDay = async ()=>{
    return await axios.post(`/api/cache/refresh_order_count_per_day`)
}

export const getClientsSalesInformation = async ()=>{
    return await axios.get(`/api/cache/fetch_clients_sales_information`)
}

export const refreshClientsSalesInformation = async ()=>{
    return await axios.post(`/api/cache/refresh_clients_sales_information`)
}

export const getClientsCountChartInfo = async () =>{
    return await axios.get(`/api/cache/fetch_clients_count_chart_info`)
}

export const refreshClientsCounts = async ()=>{
    return await axios.post(`/api/cache/refresh_clients_count`)
}

export const getClientsCountTableInfo = async () =>{
    return await axios.get(`/api/cache/fetch_clients_count_table_info`)
}

export const getSalesInformation = async () =>{
    return await axios.get(`/api/cache/fetch_operator_fe_clients_sales_information`)
}

export const refreshSalesInformation = async ()=>{
    return await axios.post(`/api/cache/refresh_operator_fe_clients_sales_information`)
}